import { render } from "./DataGrid.vue?vue&type=template&id=2d348b1e"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"

import "./DataGrid.vue?vue&type=style&index=0&id=2d348b1e&lang=scss"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__